import React from "react";
import Forwardingimage11 from "../src/public/images/whatsapp.png";
import { useContent } from "./ContentContext";

const WhatsAppIcon = () => {
  const { content, loading } = useContent();

  if (loading || !content) return null;

  const whatsappNumber = content.global.contact.whatsapp;
  const whatsappLink = `https://api.whatsapp.com/send?phone=${whatsappNumber}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        top: "90%",
        right: "15px",
        transform: "translateY(-50%)",
        padding: "12px",
        borderRadius: "50%",
        boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
        zIndex: 1000,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={Forwardingimage11}
        alt="WhatsApp"
        style={{
          width: "32px",
          height: "32px",
          objectFit: "contain",
        }}
      />
    </a>
  );
};

export default WhatsAppIcon;